const validateDomainPart = (domain: string): boolean => {
  if (!domain.includes('.')) return false;

  const parts = domain.split('.');

  if (parts.length < 2) return false;

  for (const part of parts) {
    if (part.length === 0 || part.length > 63) return false;

    if (!/^[a-zA-Z0-9]/.test(part) || !/[a-zA-Z0-9]$/.test(part)) return false;

    if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;

    // Allow numeric parts in non-TLD positions, but reject purely numeric TLDs for common cases
    if (parts.indexOf(part) === parts.length - 1 && /^\d+$/.test(part) && parts.length === 2) return false;
  }

  const tld = parts[parts.length - 1];
  if (tld.length < 2) return false;

  return true;
};

export const isDomainValid = (domain: string): boolean => {
  if (!domain || domain.trim() === '') return false;

  const trimmedDomain = domain.trim().toLowerCase();

  // Reject wildcards completely
  if (trimmedDomain.includes('*')) {
    return false;
  }

  if (!trimmedDomain.includes('.')) {
    return false;
  }

  return validateDomainPart(trimmedDomain);
};
